import { Input } from '../ui/input';

const SettingsEditor = ({ data, setData }) => {
  const d = data;
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium mb-1">نص الذيل (Footer)</label>
        <textarea value={d.footer_text || ''} onChange={e => setData({ ...d, footer_text: e.target.value })} placeholder="جميع الحقوق محفوظة..."
          className="w-full border rounded-xl p-3 min-h-[80px] resize-none text-sm focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none" data-testid="footer-text" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">رابط الشعار (اختياري)</label>
        <Input value={d.logo_url || ''} onChange={e => setData({ ...d, logo_url: e.target.value })} placeholder="https://..." dir="ltr" data-testid="logo-url" />
      </div>
    </div>
  );
};

export default SettingsEditor;
